// extracted by mini-css-extract-plugin
module.exports = {"box":"box-Tvp4PxPJ","ad":"ad-3fzmf0s0"};